"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageExtractionManager = void 0;
var deprecated_1 = require("../../utils/deprecated/deprecated");
var image_extraction_response_1 = require("./responses/image-extraction-response");
/**
 * @param {Configuration} configuration
 * @param {HTTPClient} httpClient
 * @constructor
 */
var ImageExtractionManager = /** @class */ (function () {
    function ImageExtractionManager(configuration, httpClient) {
        this.configuration = configuration;
        this.httpClient = httpClient;
        /**
         * @type {string}
         */
        this.baseUrl = "https://" + configuration.domain;
        /**
         * @type {string}
         */
        this.apiUrl = this.baseUrl + "/_api/images";
    }
    /**
     * @param {Array<string>} features -- list of supported extractors
     */
    ImageExtractionManager.prototype.getListOfSupportedExtractors = function (features) {
        if (features && features.length) {
            return features.join(',');
        }
        return 'colors,labels,explicit_content,faces';
    };
    /**
     * @returns {(response: RawResponse<ImageExtraction>) => ImageExtraction}
     */
    ImageExtractionManager.prototype.parseResponse = function () {
        return function (response) {
            return new image_extraction_response_1.ImageExtraction(response.payload);
        };
    };
    /**
     * @returns {(error) => Error}
     */
    ImageExtractionManager.prototype.errorHandler = function () {
        return function (error) { return error; };
    };
    /**
     * @param {string} fileId
     * @param {Array<string>} features -- list of supported extractors
     * @returns {Promise<ImageExtractionResponse | Error>}
     */
    ImageExtractionManager.prototype.extractImageById = function (fileId, features) {
        var listOfFeatures = this.getListOfSupportedExtractors(features);
        if (features === null) {
            deprecated_1.logDeprecated('passing features as null in extractImageById');
        }
        return this.httpClient
            .get(this.apiUrl + "/features?fileId=" + fileId + "&features=" + listOfFeatures)
            .then(this.parseResponse(), this.errorHandler());
    };
    /**
     * @param {string} path
     * @param {Array<string>} features -- list of supported extractors
     * @returns {Promise<ImageExtractionResponse | Error>}
     */
    ImageExtractionManager.prototype.extractImageByFilePath = function (path, features) {
        var listOfFeatures = this.getListOfSupportedExtractors(features);
        return this.httpClient
            .get(this.apiUrl + "/features?path=" + path + "&features=" + listOfFeatures)
            .then(this.parseResponse(), this.errorHandler());
    };
    return ImageExtractionManager;
}());
exports.ImageExtractionManager = ImageExtractionManager;
//# sourceMappingURL=image-extraction-manager.js.map